import type { StripeSiteAccount } from "../types";

export const resolveStripePublishableKey = (account?: StripeSiteAccount): string | undefined => {
  if (!account) return undefined;
  if (account === "qrnow") return process.env.NEXT_PUBLIC_STRIPE_QR_NOW_PK;
  return process.env.NEXT_PUBLIC_STRIPE_QR_CREATOR_PK;
};
